import React from 'react';
import '../styles/Logo.css';

const Logo = ({ onClick }) => {
  return (
    <div className="logo" onClick={onClick}>
        <span className="logo-university">弘前大学</span>
        <span className="logo-clerkship">Clinical Clerkship</span>
    </div>
  );
};

export default Logo; 